import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/caosconfiguration/backup/restore";

export class RestoreBackupCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: RestoreBackupReqData;

    constructor(payload: RestoreBackupReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class RestoreBackupReqData {
    backupId: number;
    constructor(backupId: number) {
        this.backupId = backupId;
    }
}
